import { enhancedApi } from '@store/generated/patient-reminders';

export const patientRemindersApi = enhancedApi.enhanceEndpoints({
  addTagTypes: ['PatientReminders'],
  endpoints: {
    getV2ProviderPatientReminders: {
      providesTags: (_result, _err, arg) => [
        { type: 'PatientReminders', id: arg.patientId },
      ],
    },
    patchV2ProviderPatientRemindersByPatientReminderId: {
      invalidatesTags: (_result, _err, _arg) =>
        _result
          ? [{ type: 'PatientReminders', id: _result.patient_id }]
          : [{ type: 'PatientReminders', id: 'LIST' }],
    },
  },
});

export const {
  useGetV2ProviderPatientRemindersQuery: useGetPatientRemindersQuery,
  usePatchV2ProviderPatientRemindersByPatientReminderIdMutation:
    useUpdatePatientReminderMutation,
} = patientRemindersApi;
